<template>
  <div class="developer-experience">
    <h3 class="developer-experience__title">
      <span>Experience</span>
      <template v-if="experience.length && !readonly">
        <v-btn
          class="developer-experience__add-btn"
          outlined
          fab
          tile
          x-small
          color="primary"
          @click="addExperienceElement"
          >
          <v-icon color="blue">mdi-plus-thick</v-icon>
        </v-btn>
      </template>
    </h3>

    <template v-if="experience.length">
      <div
        v-for="(element, index) in experience"
        :key="index"
        class="developer-experience__element">
        <div class="developer-experience__wrapper">
          <div>
            <p v-if="element.project_name" class="developer-experience__element-title">
              {{ element.project_name }}
            </p>

            <p class="developer-experience__date mb-0">
              <span v-if="element.start_date">{{ element.start_date }} - </span>
              {{ element.end_date }}
            </p>
          </div>

          <div class="developer-experience__actions">
            <v-btn
              v-if="!readonly"
              class="developer-experience__delete"
              color="primary"
              outlined
              tile
              fab
              x-small
              depressed
              @click="deleteExperienceElement(index)"
            >
              <v-icon color="primary">mdi-delete</v-icon>
            </v-btn>
            <EditBtn
              v-if="!readonly"
              class="developer-experience__edit-btn"
              @click="editExperienceElement(element, index)"/>
          </div>
        </div>
          <div
            v-if="element.about"
            class="mb-0 developer-experience__content"
            v-html="element.about">
          </div>
      </div>
    </template>

    <template v-else>
      <EmptyState outlined @click="addExperienceElement"/>
    </template>

    <ExperienceModal v-model="idEditModalVisible" :selected-experience="selectedExperience"/>
  </div>
</template>

<script>
import EmptyState from '@/components/Developers/Show/EmptyState.vue';
import EditBtn from '@/components/Developers/Show/EditBtn.vue';
import ExperienceModal from '@/components/Developers/Show/ExperienceModal.vue';

export default {
  components: {
    EmptyState,
    EditBtn,
    ExperienceModal,
  },

  props: {
    experience: {
      type: Array,
      required: true,
    },

    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      idEditModalVisible: false,
      selectedExperience: {
        context: 'add',
      },
    };
  },

  methods: {
    addExperienceElement() {
      this.selectedExperience = {
        context: 'add',
      };
      this.idEditModalVisible = true;
    },

    deleteExperienceElement(id) {
      this.$emit('delete', id);
    },

    editExperienceElement(experienceData, experienceIndex) {
      this.selectedExperience = {
        ...experienceData,
        index: experienceIndex,
        context: 'edit',
      };

      this.idEditModalVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.developer-experience {
  margin-bottom: 24px;
  padding: 16px 24px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 8px;

  &__title {
    color: $main--headers;
    font-size: 18px;
    line-height: 21px;
    font-weight: 500;
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__add-btn {
    border-radius: 4px;
    border-color: $color--secondary;
  }

  &__element {
    line-height: 20px;
    margin-top: 16px;
    position: relative;
    cursor: default;

    &:hover .developer-experience__edit-btn,
    &:hover .developer-experience__delete  {
      opacity: 1;
    }
  }

  &__edit-btn {
    opacity: 0;
  }

  &__element-title {
    font-size: 16px;
    line-height: 18px;
    font-weight: 600;
    margin-bottom: 0px;
  }

  &__date {
    font-size: 12px;
    color: $color--gray;
  }

  &__content {
    color: $color--gray;
    font-size: 16px;
    ::v-deep li p {
      margin-bottom: 0;
    }
  }

  &__actions {
    margin-left: auto;
  }

  &__delete {
    border-radius: 4px;
    border-color: $color--secondary;
    margin-right: 8px;
    margin-bottom: 8px;
    opacity: 0;
  }

  &__wrapper {
    display: flex;
    padding-bottom: 10px;;
  }
}
</style>
